import { c as _c } from "react/compiler-runtime";
import { trackNavigationHeaderClick } from '../../../../../../shared';
import type { VisualItem, VisualLayout } from '../../../../../../types';
import { BrandCard, FeatureCard, ServiceCard } from '../../../../shared';
import './visual-items-grid.scss';
type VisualItemsGridProps = {
  items: VisualItem[];
  layout: VisualLayout;
  selectionPath: string[];
};
export function VisualItemsGrid(t0) {
  const $ = _c(12);
  const {
    items,
    layout,
    selectionPath
  } = t0;
  let t1;
  if ($[0] !== selectionPath) {
    t1 = function trackItemClick(item) {
      trackNavigationHeaderClick({
        selection: [...selectionPath, item.title ?? item.label],
        linkUrl: item.href,
        navSection: "main nav"
      });
    };
    $[0] = selectionPath;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const trackItemClick = t1;
  let t2;
  if ($[2] !== items || $[3] !== layout || $[4] !== trackItemClick) {
    let t3;
    if ($[6] !== layout || $[7] !== trackItemClick) {
      t3 = item_0 => <li key={`${item_0.href}::${item_0.title ?? item_0.label}`} className="visual-items-grid__item">{layout === "imageOnly" && <BrandCard card={{
          href: item_0.href,
          imageUrl: item_0.imageUrl,
          label: item_0.label,
          openInNewTab: item_0.openInNewTab
        }} onClick={() => trackItemClick(item_0)} />}{layout === "imageWithTitle" && <ServiceCard card={{
          href: item_0.href,
          imageUrl: item_0.imageUrl,
          title: item_0.title ?? item_0.label,
          openInNewTab: item_0.openInNewTab
        }} onClick={() => trackItemClick(item_0)} />}{layout === "imageWithTitleAndDescription" && <FeatureCard card={{
          description: item_0.description,
          href: item_0.href,
          imageUrl: item_0.imageUrl,
          openInNewTab: item_0.openInNewTab,
          title: item_0.title ?? item_0.label
        }} onClick={() => trackItemClick(item_0)} />}</li>;
      $[6] = layout;
      $[7] = trackItemClick;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = items.map(t3);
    $[2] = items;
    $[3] = layout;
    $[4] = trackItemClick;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== layout || $[10] !== t2) {
    t3 = <ul aria-label="Navigation links" className="visual-items-grid" data-layout={layout}>{t2}</ul>;
    $[9] = layout;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}